import { useRef } from 'react';
import { useTheme } from 'styled-components';
import Icon, { IconType } from 'components/Icon';
import * as S from './styles';

// This state allows use the button in various ways, e.g. as a toggle button
// or as a regular button
export enum CheckboxItemState {
	ON, // toggled on
	OFF, // toggled on
}

interface CheckboxItemProps {
	state?: CheckboxItemState;
	checked?: boolean;

	// this will be called when the widget is clicked
	onToggled?: () => void;

	// optional label that will appear to the right of the checkbox
	label?: string;
	width?: number;
	height?: number;
}

const CheckboxItem = ({
	checked,
	state,
	onToggled,
	label,
	width = 20,
	height = 20,
}: CheckboxItemProps) => {
	const ref = useRef(null);
	const theme = useTheme();

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------
	const onClick = (event: any) => {
		// make sure we're clicking the button! (and not the tooltips, which also trigger this event)
		if (event.target === ref.current) {
			if (onToggled) {
				// If we have an onSelected handler, don't let the event propagate
				event?.stopPropagation();
				event?.preventDefault();
				onToggled();
			}
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	return (
		<S.Base ref={ref} onClick={onClick}>
			<S.Icon>
				<Icon
					type={
						state === CheckboxItemState.ON || checked ? IconType.CHECKBOX_ON : IconType.CHECKBOX_OFF
					}
					width={width}
					height={height}
					color={theme.gray['1000']}
				/>
			</S.Icon>
			{label && <S.Label>{label}</S.Label>}
		</S.Base>
	);
};

export default CheckboxItem;
